import React, {useState} from 'react';
import Modal from "../../components/modal/modal";
import ErrorMsg from "../../components/error-msg/error-msg";
import DateTimePicker from 'react-datetime-picker';
import './react-datetime-picker.scss';
import Button from "../../components/button/button";

const ScheduleModal = ({initDate, onClose, onSet, onSubmit,type}) => {
    const [date, setDate] = useState(initDate || new Date());
    return (
        <Modal
            onClose={onClose}
            title={type? window.L("teach.course.single"):window.L("teach.course.batchSchedule")}
            tips={type? window.L("teach.course.singleTips"):window.L("teach.course.batchScheduleTips")}
            >
            <div style={{margin: "2rem", textAlign: "center"}}>
                <DateTimePicker
                    onChange={setDate}
                    value={date}
                    />
            </div>
            <div style={{textAlign: 'center'}}>
                <Button
                    theme={"submit"}
                    label={window.L("teach.button.set")}
                    onClick={() => {
                        onSet(date);
                        onSubmit();
                    }}
                    />
            </div>
        </Modal>
    );
}

export default ScheduleModal;
